import React, { Component } from 'react'
import Modal from 'react-modal'
import { withRouter } from 'react-router-dom'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'
import CreditAssessmentDateModalUI from './CreditAssessmentDateModalUI.js'

class CreditAssessmentDateModalSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      successMsg: null,
      errorList: null,
      // form events
      submitted: false,
      // form field
      creditAssessmentDate: this.props.account.documentStatus.creditAssessmentDateISO,
      dateError: null,
    }
  }

  render() {
    return (
      <CreditAssessmentDateModalUI
        context={this.props.context}
        errorList={this.state.errorList}
        successMsg={this.state.successMsg}
        setErrorList={this.setErrorList}
        // modes
        updateMode={this.props.updateMode}
        submitted={this.state.submitted}
        // event handlers
        onSubmit={this.onSubmit}
        onCancelClick={this.props.onCancelClick}
        // form fields
        creditAssessmentDate={this.state.creditAssessmentDate}
        onDateChange={(creditAssessmentDate) => { this.setState({ creditAssessmentDate: creditAssessmentDate }) }}
        dateError={this.state.dateError}
        setDateError={(error) => { this.setState({ dateError: error }) }}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    Modal.setAppElement('body')
  }

  onSubmit = () => {
    let submitted = this.state.submitted
    if (submitted)
      return

    this.setState({
      successMsg: null,
      errorList: [],
      submitted: true
    })

    RestApiUtils.put(this.props.context,
      `/api/su/accounts/${this.props.account.accountId}/creditAssesments/date`,
      this.onSubmitCallback, {
        creditAssessmentDate: this.state.creditAssessmentDate,
      }
    )
  }

  onSubmitCallback = (response) => {
    let errorList = []
    response.errorList.forEach(error => {
      errorList.push(error.message)
    })

    this.setState({
      successMsg: response.success,
      errorList: errorList,
      submitted: false
    })

    this.props.account.documentStatus.creditAssessmentDateF1 = this.state.creditAssessmentDate
    console.log(this.props.account);
    this.props.onAccountUpdate(this.props.account)

    if (response.errorList.length === 0) {
      setTimeout(() => {
        this.setState({
          successMsg: null
        })
        this.props.onCancelClick()
      }, 1000)
    }
  }

  setErrorList = (errorList) => {
    this.setState({errorList: errorList})
  }
}

export default withRouter(CreditAssessmentDateModalSF)
